"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayer = void 0;
var shaka_player_1 = require("shaka-player");
var flatten_1 = __importDefault(require("lodash/flatten"));
var utils_1 = require("./utils");
var debug_1 = __importDefault(require("debug"));
var log = debug_1.default('persie:player');
var InfoPanelStorageKey = 'sc_video_info_panel_enabled';
var InfoPanelTemplate = "\n<div data-label=\"info-panel\" style=\"position: absolute; top: 10px; left: 10px; z-index: 100; background: rgba(28,28,28,0.8); color: #fff; padding:5px;\">\n<table style=\"border-collapse: collapse; border: 1px solid #000;\">\n  <tr>\n    <td style=\"padding: 5px; border: 1px solid #000;\">Frames</td>\n    <td style=\"padding: 5px; border: 1px solid #000;\" data-label=\"frames\"> -- </td>\n  </tr>\n  <tr>\n  <td style=\"padding: 5px; border: 1px solid #000;\">Viewport / Screen</td>\n  <td style=\"padding: 5px; border: 1px solid #000;\" data-label=\"viewport\"> -- </td>\n</tr>\n  <tr>\n    <td style=\"padding: 5px; border: 1px solid #000;\">Current / Max Resolution</td>\n    <td style=\"padding: 5px; border: 1px solid #000;\" data-label=\"resolution\"> -- </td>\n  </tr>\n  <tr>\n    <td style=\"padding: 5px; border: 1px solid #000;\">Codecs</td>\n    <td style=\"padding: 5px; border: 1px solid #000;\" data-label=\"codecs\"> -- </td>\n  </tr>\n  <tr>\n    <td style=\"padding: 5px; border: 1px solid #000;\">Chrome</td>\n    <td style=\"padding: 5px; border: 1px solid #000;\" data-label=\"chrome\"> -- </td>\n  </tr>\n</table>\n</div>\n";
;
var VideoPlayer = /** @class */ (function () {
    function VideoPlayer(videoContainer, configuration, onDestroy) {
        var _this = this;
        this.videoContainer = videoContainer;
        this.configuration = configuration;
        this.onDestroy = function () { return undefined; };
        this.videoEventListeners = new utils_1.ListenerCounter();
        this.playerEventListeners = new utils_1.ListenerCounter();
        this.destroyPromise = null;
        this.infoPanel = null;
        this.infoPanelUpdateOperation = null;
        this.handleError = this.handleError.bind(this);
        this.handleVideoEvent = this.handleVideoEvent.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        if (onDestroy) {
            this.onDestroy = onDestroy;
        }
        this.videoElement = (this.videoContainer.getElementsByTagName('video'))[0];
        this.player = new shaka_player_1.Player(this.videoElement);
        this.videoConf = this.applyConfiguration();
        if (!this.videoElement) {
            log('No video element found in the container!');
            return;
        }
        this.configureVideoElement();
        this.player.getNetworkingEngine().registerRequestFilter(function (requestType, request) {
            // This is an ugly hack to be able to have access to the player instance in networking engine's static scheme handling methods
            // There has been discussions to add this already to scheme handlers but not implemented: 
            // https://github.com/google/shaka-player/issues/1718#issuecomment-444580831
            // @ts-ignore
            request._videoPlayer = _this;
        });
        // TODO add types for shaka configuration
        var shakaConf = {
            abr: { enabled: this.videoConf.abr },
            streaming: {
                bufferingGoal: this.videoConf.bufferingGoal
            }
        };
        log('Conf', { videoConf: this.videoConf, shakaConf: shakaConf });
        this.player.configure(shakaConf);
        this.player.addEventListener('loading', function (ev) {
            log(ev.type, ev);
        });
        this.player.addEventListener('streaming', function (ev) {
            var _a;
            _this.handleVariantTracks(); // variant tracks are ready but not started streaming yet.
            (_a = _this.infoPanelUpdateOperation) === null || _a === void 0 ? void 0 : _a.start();
            log(ev.type, ev);
        });
        this.player.addEventListener('manifestparsed', function (ev) {
            log(ev.type, ev);
        });
        this.player.addEventListener('abrstatuschanged', function (ev) { return log(ev.type, ev); });
        // Listen for error events.
        this.player.addEventListener('error', this.handleError);
        this.videoElement.addEventListener('ended', this.handleVideoEvent);
        this.openInfoPanel();
    }
    VideoPlayer.prototype.onPlayerEvent = function (type, handler) {
        this.player.addEventListener(type, handler);
        this.playerEventListeners.add(type, handler);
    };
    VideoPlayer.prototype.onVideoEvent = function (type, handler) {
        this.videoElement.addEventListener(type, handler);
        this.videoEventListeners.add(type, handler);
    };
    VideoPlayer.prototype.offVideoEvent = function (type, handler) {
        this.videoElement.removeEventListener(type, handler);
        this.videoEventListeners.remove(type, handler);
    };
    VideoPlayer.prototype.removePlayerEvents = function () {
        var _this = this;
        this.playerEventListeners.getAll().forEach(function (_a) {
            var _b = __read(_a, 2), type = _b[0], listeners = _b[1];
            listeners.forEach(function (l) { return _this.player.removeEventListener(type, l); });
            _this.playerEventListeners.removeAll(type);
        });
    };
    VideoPlayer.prototype.removeVideoEvents = function () {
        var _this = this;
        this.videoEventListeners.getAll().forEach(function (_a) {
            var _b = __read(_a, 2), type = _b[0], listeners = _b[1];
            listeners.forEach(function (l) { return _this.videoElement.removeEventListener(type, l); });
            _this.videoEventListeners.removeAll(type);
        });
    };
    VideoPlayer.prototype.applyConfiguration = function () {
        var defaultMinResolution = {
            width: 1000
        };
        var defaultConfiguration = {
            src: '',
            isLive: false,
            abr: false,
            bufferingGoal: 20.0,
            shallCache: true,
            minResolution: defaultMinResolution,
            loop: false,
            muted: undefined,
            controls: undefined,
            autoplay: false
        };
        var _a = this.configuration, minResolutionInput = _a.minResolution, restOfConfiguration = __rest(_a, ["minResolution"]);
        var minResolution = utils_1.parseResolution(minResolutionInput) || defaultMinResolution;
        var mergedConfiguration = Object.assign({}, defaultConfiguration, restOfConfiguration, { minResolution: minResolution });
        // src from dataset has priority
        if (this.videoContainer.dataset.src) {
            mergedConfiguration.src = this.videoContainer.dataset.src;
        }
        // resolve if it is relative path
        mergedConfiguration.src = new URL(mergedConfiguration.src, location.href).href;
        // Sanity checks
        if (mergedConfiguration.isLive) {
            mergedConfiguration.abr = true;
            mergedConfiguration.shallCache = false;
        }
        return mergedConfiguration;
    };
    VideoPlayer.prototype.getConfiguration = function () {
        return this.videoConf;
    };
    VideoPlayer.prototype.configureVideoElement = function () {
        if (!this.videoElement)
            return;
        var _a = this.videoConf, muted = _a.muted, controls = _a.controls;
        if (muted) {
            this.videoElement.muted = muted;
        }
        if (controls !== undefined) {
            this.videoElement.controls = controls;
        }
    };
    VideoPlayer.prototype.isLive = function () {
        // We do not know if the stream is live until manifest is parsed so check 
        // what our configuration says first and then ask the shaka player
        if (this.videoConf.isLive) {
            return true;
        }
        return this.player.isLive();
    };
    VideoPlayer.prototype.load = function (startTime, mimeType) {
        return __awaiter(this, void 0, void 0, function () {
            var manifestUri;
            var _this = this;
            return __generator(this, function (_a) {
                manifestUri = this.videoConf.src;
                if (!manifestUri) {
                    throw new Error('Manifest uri is not provided in dataset');
                }
                log('Loading video:', { manifestUri: manifestUri, startTime: startTime });
                // When startTime undefined, playback will start at the default start time 
                // (startTime=0 for VOD and startTime=liveEdge for LIVE
                return [2 /*return*/, this.player.load(manifestUri, startTime, mimeType).then(function () {
                        // This runs if the asynchronous load is successful.
                        log('Video loaded:', { manifestUri: manifestUri, startTime: startTime });
                        if (_this.videoConf.autoplay) {
                            return _this.play();
                        }
                    }).catch(function (err) {
                        log('Loading failed', err);
                        throw err;
                    })];
            });
        });
    };
    VideoPlayer.prototype.play = function (fromStart) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.videoElement)
                    return [2 /*return*/];
                if (fromStart) {
                    this.videoElement.currentTime = 0;
                }
                return [2 /*return*/, this.videoElement.play()];
            });
        });
    };
    VideoPlayer.prototype.pause = function () {
        if (!this.videoElement)
            return null;
        return this.videoElement.pause();
    };
    VideoPlayer.prototype.seek = function (startTime) {
        var end = this.player.seekRange().end;
        if (startTime < end) {
            this.videoElement.currentTime = startTime;
            return true;
        }
        return false;
    };
    VideoPlayer.prototype.trickPlay = function (rate) {
        // a rate of 2.5 would result in 2.5 seconds of content being skipped every second
        return this.player.trickPlay(rate);
    };
    VideoPlayer.prototype.cancelTrickPlay = function () {
        return this.player.cancelTrickPlay();
    };
    VideoPlayer.prototype.handleVideoEvent = function (ev) {
        log('Video event', ev);
        switch (ev.type) {
            case 'ended':
                if (this.videoConf.loop) {
                    this.play();
                }
                break;
            default:
                break;
        }
    };
    VideoPlayer.prototype.handleError = function (ev) {
        // Extract the shaka.util.Error object from the event.
        log('HandleError', ev.detail || ev);
    };
    VideoPlayer.prototype.handleVariantTracks = function () {
        var e_1, _a;
        var _tracks = this.player.getVariantTracks();
        var sortedTracks = _tracks.sort(function (t1, t2) {
            var _a, _b, _c, _d;
            var width1 = (_a = t1.width) !== null && _a !== void 0 ? _a : 0;
            var width2 = (_b = t2.width) !== null && _b !== void 0 ? _b : 0;
            var height1 = (_c = t1.height) !== null && _c !== void 0 ? _c : 0;
            var height2 = (_d = t2.height) !== null && _d !== void 0 ? _d : 0;
            return width1 === width2 ? height1 - height2 : width1 - width2;
        }); // sort in increasing order
        log('Available tracks:', sortedTracks);
        var maxTrack = sortedTracks[sortedTracks.length - 1];
        var selectedTrack = maxTrack; // default is the highest width 
        try {
            for (var sortedTracks_1 = __values(sortedTracks), sortedTracks_1_1 = sortedTracks_1.next(); !sortedTracks_1_1.done; sortedTracks_1_1 = sortedTracks_1.next()) {
                var track = sortedTracks_1_1.value;
                var width = track.width, height = track.height;
                if (width) {
                    if (width >= this.videoConf.minResolution.width
                        && (!this.videoConf.minResolution.height || (height && height >= this.videoConf.minResolution.height))) {
                        selectedTrack = track;
                        break;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sortedTracks_1_1 && !sortedTracks_1_1.done && (_a = sortedTracks_1.return)) _a.call(sortedTracks_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.updateInfoPanel({
            resolution: utils_1.printTrack(selectedTrack) + " / " + utils_1.printTrack(maxTrack),
            codecs: utils_1.printCodecs(selectedTrack),
        });
        log('Selected track', selectedTrack);
        this.player.selectVariantTrack(selectedTrack);
    };
    VideoPlayer.prototype.getActiveVariantTrack = function () {
        return this.player.getVariantTracks().find(function (t) { return t.active; });
    };
    VideoPlayer.prototype.getCodecInfo = function () {
        var activeTrack = this.getActiveVariantTrack();
        var _a = activeTrack || { audioCodec: 'N/A', videoCodec: 'N/A' }, audioCodec = _a.audioCodec, videoCodec = _a.videoCodec;
        return {
            audioCodec: audioCodec,
            videoCodec: videoCodec
        };
    };
    VideoPlayer.prototype.getActiveSegments = function () {
        function getSegmentsOfStream(stream) {
            var list = [];
            if (stream) {
                var i = stream.findSegmentPosition(0);
                while (true) {
                    var seg = stream.getSegmentReference(i);
                    if (!seg)
                        break;
                    list.push(seg);
                    i++;
                }
            }
            return list;
        }
        var segments = [];
        // How to get segments discussed here: https://github.com/google/shaka-player/issues/1074
        var manifest = this.player.getManifest();
        if (manifest) {
            var activeTrack_1 = this.getActiveVariantTrack();
            if (activeTrack_1) {
                var allVariants = flatten_1.default(manifest.periods.map(function (p) { return p.variants; }));
                var activeVariant = allVariants.find(function (v) { return v.id == activeTrack_1.id; });
                if (activeVariant) {
                    var audio = activeVariant.audio, video = activeVariant.video;
                    segments.push.apply(segments, __spread(getSegmentsOfStream(audio), getSegmentsOfStream(video)));
                }
            }
        }
        return segments;
    };
    VideoPlayer.prototype.getActiveSegmentUris = function () {
        var segments = this.getActiveSegments();
        return flatten_1.default(segments.map(function (s) { return s.createUris(); }));
    };
    VideoPlayer.prototype.detach = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.player.detach()];
            });
        });
    };
    VideoPlayer.prototype.probeSupport = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, shaka_player_1.Player.probeSupport()];
            });
        });
    };
    VideoPlayer.prototype._destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pause();
                        this.removeVideoEvents();
                        this.removePlayerEvents();
                        this.closeInfoPanel();
                        return [4 /*yield*/, this.detach()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.player.destroy()];
                    case 2:
                        _a.sent();
                        this.onDestroy(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoPlayer.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.destroyPromise = this._destroy();
                return [2 /*return*/, this.destroyPromise];
            });
        });
    };
    VideoPlayer.prototype.isDestroying = function () {
        return !!this.destroyPromise;
    };
    VideoPlayer.prototype.waitUntilDestroyed = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isDestroying()) {
                    throw new Error('Video player is not destroying!');
                }
                return [2 /*return*/, this.destroyPromise];
            });
        });
    };
    VideoPlayer.prototype.openInfoPanel = function () {
        var _this = this;
        var updateFrames = function () {
            var _a = _this.player.getStats(), droppedFrames = _a.droppedFrames, corruptedFrames = _a.corruptedFrames, decodedFrames = _a.decodedFrames;
            _this.updateInfoPanel({
                frames: droppedFrames + " dropped, " + corruptedFrames + " corrupted of " + decodedFrames + " frames"
            });
        };
        try {
            var isEnabled = localStorage.getItem(InfoPanelStorageKey);
            if (isEnabled === 'true' || isEnabled == '1') {
                this.videoContainer.insertAdjacentHTML('beforeend', InfoPanelTemplate);
                this.infoPanel = this.videoContainer.lastElementChild;
                this.infoPanelUpdateOperation = new utils_1.PeriodicOperation(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        updateFrames();
                        return [2 /*return*/];
                    });
                }); }, 5000);
                this.updateInfoPanel({
                    chrome: utils_1.getChromeVersion(),
                    viewport: utils_1.getViewportAndScreen(),
                });
                window.addEventListener('resize', this.handleWindowResize);
            }
        }
        catch (err) {
            log('Open info panel error:', err);
        }
    };
    VideoPlayer.prototype.handleWindowResize = function () {
        this.updateInfoPanel({
            viewport: utils_1.getViewportAndScreen(),
        });
    };
    VideoPlayer.prototype.updateInfoPanel = function (infoPanelData) {
        var _this = this;
        if (!this.infoPanel)
            return;
        Object.keys(infoPanelData).forEach(function (key) {
            var _a;
            var value = infoPanelData[key];
            var element = (_a = _this.infoPanel) === null || _a === void 0 ? void 0 : _a.querySelector("[data-label=" + key + "]");
            if (element) {
                element.textContent = value;
            }
        });
    };
    VideoPlayer.prototype.closeInfoPanel = function () {
        var _a;
        (_a = this.infoPanelUpdateOperation) === null || _a === void 0 ? void 0 : _a.stop();
        window.removeEventListener('resize', this.handleWindowResize);
        if (this.infoPanel) {
            this.videoContainer.removeChild(this.infoPanel);
        }
    };
    return VideoPlayer;
}());
exports.VideoPlayer = VideoPlayer;
